// extracted by mini-css-extract-plugin
module.exports = {"date-footer":"DateFooter_date-footer__3zB0w"};